"use client";
import React from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  children: React.ReactNode; // @note: dev only
  className?: string;
}
export interface MultiColumnProps extends Props {
  columns: number;
  loading?: boolean;
}
const MasonryBody = ({ children }: Props) => {
  return <>{children}</>;
};

const SingleColumn = ({ children, className }: Props) => (
  <div className={className}>{children}</div>
);

const MultiColumn = ({
  columns,
  loading = false,
  children,
  className,
}: MultiColumnProps) => {
  if (loading) return <div>Loading...</div>;
  if (!children) return <div>No items.</div>;

  function generateColumns() {
    const allColumns: any[] = [];

    for (let i = 1; i <= columns; i++) {
      allColumns.push(generateSingleColumn(i));
    }

    return (
      <div className={twMerge(`flex gap-5 justify-center`, className)}>
        {allColumns}
      </div>
    );
  }

  function generateSingleColumn(column: number) {
    const widgetsInSingleColumn: any[] = [];
    const iterableChildren = React.Children.toArray(children);

    for (let i = column; i <= iterableChildren.length; i += columns) {
      widgetsInSingleColumn.push(iterableChildren[i - 1]);
    }

    return (
      <div className="flex-1" key={column}>
        {widgetsInSingleColumn}
      </div>
    );
  }

  return generateColumns();
};

MasonryBody.SingleColumn = SingleColumn;
MasonryBody.MultiColumn = MultiColumn;

export default MasonryBody;
